import React from 'react';
import { TablePagination } from '@mui/material';
import { PaginationWrapper } from './LMA.style';

interface PaginationControlsProps {
  totalPages: number;
  currentPage: number;
  pageSize: number;
  totalItems: number;
  onPageChange: (event: React.ChangeEvent<unknown>, page: number) => void;
  onPageSizeChange?: (newPageSize: number) => void;
}

const PaginationControls: React.FC<PaginationControlsProps> = ({
  currentPage,
  pageSize,
  totalItems,
  onPageChange,
  onPageSizeChange,
}) => {
  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    // TablePagination uses 0-based indexing, convert to 1-based for our app
    onPageChange(event as any, newPage + 1);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const newPageSize = parseInt(event.target.value, 10);
    if (onPageSizeChange) {
      onPageSizeChange(newPageSize);
    }
  };

  return (
    <PaginationWrapper>
      <TablePagination
        rowsPerPageOptions={[10, 20, 30]}
        component="div"
        count={totalItems}
        rowsPerPage={pageSize}
        page={currentPage - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage="Rows per page:"
        labelDisplayedRows={() => ''}
        sx={{
          '& .MuiTablePagination-actions': {
            marginLeft: '-30px',
          },
          '& .MuiTablePagination-displayedRows': {
            display: 'none',
          },
        }}
      />
    </PaginationWrapper>
  );
};

export default PaginationControls;
